import { REGEX_URL_NAME } from '@/constants/constants';


export default {
  name: 'SignInSuccess',

  props: {
    ticket: {
      type: String,
      default: '',
    },
  },

  mounted() {
    if (this.$store.getters.redirectUri) {
      this.redirectUri = this.$store.getters.redirectUri;
    }

    const urlMotmom = process.env.VUE_APP_MOTMOM_URL.match(REGEX_URL_NAME)[3];

    this.redirectUriName = this.redirectUri ? this.redirectUri : urlMotmom;
    this.redirectUri = this.redirectUri ? this.redirectUri : process.env.VUE_APP_MOTMOM_URL;
  },


  methods: {
    signOut() {
      clearInterval(this.localTimerId);
      this.$emit('onSignOut');
    },

    setTimer() {
      this.localTimerId = setInterval(
        () => {
          this.timeOut -= 1;

          if (this.timeOut === 0) {
            clearInterval(this.localTimerId);
            const ticket = this.ticket ? `?ticket=${this.ticket}` : '';
            window.location.href = `${this.redirectUri}${ticket}`;
          }
        },
        1000,
      );
    },
  },

  created() {
    this.timeOut = 5;
    this.setTimer();
  },

  beforeDestroy() {
    clearInterval(this.localTimerId);
  },

  data() {
    return {
      redirectUri: this.redirectUri,
      redirectUriName: this.redirectUriName,
    };
  },
};
